// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "flowbite/dist/flowbite.turbo.js"
import "./controllers"

// for hiding turbo frame after stream
Turbo.StreamActions.hide = function () {
    this.targetElements.forEach((target) => {
        target.classList.add('hidden')
    });
};

window.document.addEventListener("turbo:render", () => {
    window.initFlowbite();
});
//
// window.document.addEventListener("turbo:submit-end", (_event) => {
//     window.setTimeout(() => {
//         window.initFlowbite();
//     }, 10);
// });
